var _a;
import { __assign } from "tslib";
import { PluginKey } from 'prosemirror-state';
import { pluginFactory } from '../../../utils/plugin-state-factory';
import reducer from '../reducer';
import { handleDocOrSelectionChanged } from '../handlers';
export var pluginKey = new PluginKey('tablePlugin');
export var createPluginState = (_a = pluginFactory(pluginKey, reducer, {
    mapping: function (tr, pluginState) {
        if (tr.docChanged && pluginState.targetCellPosition) {
            var _a = tr.mapping.mapResult(pluginState.targetCellPosition), pos = _a.pos, deleted = _a.deleted;
            return __assign(__assign({}, pluginState), { targetCellPosition: deleted ? undefined : pos });
        }
        return pluginState;
    },
    onDocChanged: handleDocOrSelectionChanged,
    onSelectionChanged: handleDocOrSelectionChanged,
}), _a.createPluginState), createCommand = _a.createCommand, getPluginState = _a.getPluginState;
//# sourceMappingURL=plugin-factory.js.map